export const balance = (key,balance) => ({
  type: 'WALLET_BALANCE',
  key,
  balance
})